<template>
  <div class="min-h-screen flex items-center flex-col py-8 w-full px-4">
    <div class="flex flex-col w-full md:w-1/3 justify-start text-center items-center">
      <p class="text-lg font-normal leading-loose">ผลการทำแบบประเมิน</p>
      <p class="text-base font-normal">
        คุณภาพชีวิตขององค์การอนามัยโลก (WHOQOL - BREF – THAI)
      </p>
      <div
        class="rounded-full w-40 h-40 text-center flex items-center justify-center mt-6"
        :class="finalResultColors.find((color) => color.result == finalResult).color"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 511.997 511.997"
          class="mr-3 h-24 w-24 text-white fill-current ml-4"
        >
          <path
            d="M157.897 185.906c-3.217-2.609-7.939-2.117-10.549 1.101-3.03 3.736-7.047 5.793-11.313 5.793-4.266 0-8.283-2.058-11.313-5.793-2.609-3.217-7.333-3.709-10.549-1.101-3.217 2.609-3.71 7.332-1.101 10.549 5.847 7.21 14.217 11.345 22.963 11.345s17.115-4.135 22.963-11.345c2.609-3.217 2.116-7.94-1.101-10.549zM101.759 141.386c-4.142 0-7.5 3.358-7.5 7.5v8.569c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-8.569c0-4.142-3.358-7.5-7.5-7.5zM170.311 141.386c-4.142 0-7.5 3.358-7.5 7.5v8.569c0 4.142 3.357 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-8.569c0-4.142-3.358-7.5-7.5-7.5zM406.397 228.75c-3.217-2.609-7.94-2.117-10.549 1.101-3.03 3.735-7.048 5.793-11.313 5.793-4.266 0-8.283-2.058-11.313-5.793-2.608-3.217-7.332-3.71-10.549-1.101-3.217 2.609-3.709 7.332-1.1 10.549 5.846 7.211 14.216 11.345 22.962 11.345s17.115-4.135 22.962-11.345c2.609-3.217 2.117-7.94-1.1-10.549zM350.259 184.231c-4.142 0-7.5 3.358-7.5 7.5v8.569c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-8.569c0-4.142-3.358-7.5-7.5-7.5zM418.811 184.231c-4.142 0-7.5 3.358-7.5 7.5v8.569c0 4.142 3.357 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-8.569c0-4.142-3.358-7.5-7.5-7.5z"
          />
          <path
            d="M491.126 332.545l-58.757-23.503c-.318-.127-.612-.289-.91-.445 40.583-9.234 59.803-24.676 60.656-25.375a7.5009 7.5009 0 002.671-6.862c-.085-.594-8.494-60.135-8.494-118.904 0-56.11-45.649-101.759-101.759-101.759s-101.758 45.648-101.758 101.759c0 15.374-.698 34.178-1.834 51.979l-16.373 8.187-48.06-24.029c-.138-.069-.283-.119-.424-.179 2.286-6.663 3.781-13.689 4.33-20.98 10.053-3.106 17.378-12.487 17.378-23.547 0-7.449-3.328-14.131-8.569-18.653v-49.9c0-13.785-6.965-26.683-18.387-34.433-3.87-14.38-16.79-24.481-31.958-24.481h-68.552c-37.21 0-67.483 30.273-67.483 67.483v41.33c-5.241 4.521-8.569 11.204-8.569 18.653 0 11.06 7.325 20.441 17.378 23.547 1.894 25.179 14.87 47.302 34.036 61.54v20.73L23.664 273.31C9.51 277.557 0 290.338 0 305.116v83.701c0 4.142 3.358 7.5 7.5 7.5h1.069v86.759c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-86.759h27.845v86.759c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-129.32c0-6.578-1.929-12.948-5.577-18.42l-12.82-19.23c-2.298-3.447-6.955-4.377-10.4-2.081-3.447 2.297-4.378 6.954-2.08 10.401l12.82 19.231c2 3 3.058 6.492 3.058 10.099v27.561H15v-76.201c0-8.103 5.214-15.11 12.976-17.439l25.747-7.724c8.966 37.542 43.017 64.95 82.312 64.95 14.117 0 27.827-3.481 40.104-10.105 4.487 6.121 11.724 10.105 19.878 10.105h1.069v1.069c0 25.143 13.832 47.103 34.276 58.712v12.233c0 .46-.294.868-.731 1.014l-27.977 9.326c-13.581 4.527-22.706 17.187-22.706 31.503v24.316c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5V458.76c0-7.849 5.003-14.791 12.449-17.272l8.227-2.743c10.884 16.232 29.189 26.125 48.944 26.125 19.776 0 38.064-9.887 48.946-26.124l8.225 2.742a18.1831 18.1831 0 0112.449 17.272v24.316c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5V458.76c0-14.316-9.125-26.976-22.706-31.502l-27.977-9.326a1.0679 1.0679 0 01-.731-1.014v-12.233c15.307-8.692 26.893-23.188 31.753-40.481 14.173 14.83 33.968 23.546 55.005 23.546 33.212 0 62.353-21.469 72.391-52.728l28.629 11.451c6.953 2.781 11.445 9.417 11.445 16.904v35.079h-27.845v-9.638c0-4.142-3.358-7.5-7.5-7.5-4.142 0-7.5 3.358-7.5 7.5v94.259c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-69.621h19.276v69.621c0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-69.621h1.069a7.4992 7.4992 0 007.5-7.5v-42.579c.003-13.658-8.19-25.76-20.871-30.832zm-193.35-175.09c0-47.839 38.92-86.759 86.759-86.759s86.758 38.92 86.758 86.759c0 50.363 6.065 101.274 8.036 116.479-6.721 4.397-23.929 14.081-53.018 20.445v-11.935c3.984-2.258 7.798-4.835 11.384-7.733 14.758-11.929 25.187-28.636 29.363-47.042 1.392-6.133 2.098-12.458 2.098-18.799 0-42.391-30.657-48.477-60.305-54.363-18.865-3.745-38.372-7.618-53.906-20.045-2.251-1.801-5.335-2.152-7.934-.903a7.4984 7.4984 0 00-4.251 6.76c0 .199-.327 19.933-28.595 27-4.019 1.005-6.462 5.077-5.457 9.096 1.004 4.019 5.077 6.46 9.095 5.457 23.66-5.915 33.312-19.188 37.248-29.16 16.264 9.638 34.483 13.254 50.879 16.509 31.689 6.291 48.226 10.912 48.226 39.65 0 5.226-.581 10.434-1.726 15.48-3.435 15.134-12.016 28.876-24.165 38.696-12.5 10.104-27.622 15.444-43.73 15.444-14.684 0-28.659-4.504-40.519-13.015-4.345-11.859-11.324-22.709-20.533-31.649v-33.525c0-2.6-1.346-5.014-3.557-6.38a7.4997 7.4997 0 00-7.297-.328l-16.193 8.096c.888-15.619 1.34-30.469 1.34-44.235zm10.707 54.98v27.143l-27.144-13.571 27.144-13.572zm-87.828 0l27.143 13.572-27.143 13.571v-27.143zm-40.707 82.123v7.123c-5.37 4.637-8.569 11.423-8.569 18.583-10.682 6.311-22.817 9.639-35.345 9.639-32.624 0-60.849-22.958-67.91-54.27l18.529-5.559c4.571 23.088 24.972 40.553 49.382 40.553 19.383 0 36.231-11.017 44.641-27.112a84.332 84.332 0 00-.728 11.043zM100.69 260.27v-17.373c10.762 4.97 22.734 7.747 35.345 7.747 12.61 0 24.583-2.778 35.345-7.746v17.383c0 19.489-15.855 35.345-35.345 35.345-19.457 0-35.29-15.804-35.343-35.249 0-.036-.002-.072-.002-.107zm35.345-24.626c-38.39 0-69.621-31.231-69.621-69.62 0-4.142-3.358-7.5-7.5-7.5-5.314 0-9.638-4.324-9.638-9.638s4.323-9.638 9.638-9.638h17.138c3.228 0 6.094-2.065 7.115-5.128l6.884-20.652c17.235-.389 70.664-2.812 100.751-17.856 3.705-1.853 5.207-6.357 3.354-10.062-1.852-3.705-6.356-5.207-10.062-3.354-32.281 16.14-98.807 16.346-99.475 16.346-3.228.001-6.094 2.066-7.114 5.129l-6.859 20.578H58.914c-.358 0-.714.012-1.069.027V88.903c0-28.939 23.544-52.483 52.483-52.483h68.552c8.956 0 16.48 6.455 17.893 15.347a7.4997 7.4997 0 003.723 5.356c8.468 4.776 13.729 13.669 13.729 23.21v43.941c-.355-.016-.71-.027-1.069-.027h-8.569c-4.142 0-7.5 3.358-7.5 7.5 0 4.142 3.358 7.5 7.5 7.5h8.569c5.314 0 9.638 4.323 9.638 9.638s-4.323 9.638-9.638 9.638c-4.142 0-7.5 3.358-7.5 7.5 0 38.389-31.231 69.621-69.621 69.621zm50.344 24.639v-26.31c7.461-5.543 13.982-12.276 19.276-19.928v19.781c-8.399 8.154-14.946 17.895-19.329 28.543.029-.693.053-1.387.053-2.086zm112.169 173.473c-8.257 10.087-20.661 16.113-33.979 16.113-13.302 0-25.714-6.03-33.974-16.114l4.78-1.593a16.0482 16.0482 0 0010.988-15.244v-5.978c5.796 1.627 11.898 2.516 18.207 2.516 6.309 0 12.411-.889 18.207-2.516v5.978a16.0444 16.0444 0 0010.987 15.243l4.784 1.595zm26.005-103.853c-4.142 0-7.5 3.358-7.5 7.5v7.457c0 .065-.001.13 0 .195v.917c-.001 28.939-23.545 52.483-52.484 52.483s-52.482-23.544-52.482-52.483v-8.569c0-4.142-3.358-7.5-7.5-7.5h-8.569c-5.314 0-9.638-4.323-9.638-9.638 0-3.42 1.81-6.515 4.841-8.279.677-.394 1.266-.893 1.776-1.457 18.54-.537 78.639-4.026 118.138-26.597 3.596-2.055 4.846-6.636 2.791-10.233-2.055-3.597-6.638-4.846-10.233-2.791-34.602 19.772-88.974 23.731-108.744 24.522v-.872c0-13.949 4.224-27.458 11.878-38.847.599.949 1.4 1.773 2.386 2.382a7.5013 7.5013 0 003.943 1.12c1.146 0 2.295-.263 3.354-.792l48.06-24.03 48.06 24.03c1.059.529 2.208.792 3.354.792 1.372 0 2.739-.376 3.943-1.12.985-.609 1.786-1.434 2.385-2.382 7.654 11.389 11.878 24.898 11.878 38.847v10.946c0 2.67 1.419 5.139 3.728 6.482 3.032 1.765 4.842 4.859 4.842 8.279 0 5.314-4.324 9.638-9.638 9.638h-8.569zm59.982 42.845c-20.764 0-40.028-10.571-51.242-27.849 13.506-.093 24.466-11.106 24.466-24.633 0-7.16-3.199-13.947-8.569-18.584v-7.123c0-3.019-.163-6.021-.482-8.995 11.121 5.214 23.263 7.925 35.827 7.925 9.145 0 18.189-1.515 26.776-4.379v10.983c0 10.133 6.079 19.113 15.487 22.876l16.173 6.469c-7.751 25.628-31.421 43.31-58.436 43.31z"
          />
          <path
            d="M286.432 357.285c-3.217-2.609-7.94-2.117-10.549 1.101-3.031 3.736-7.048 5.793-11.313 5.793-4.265 0-8.283-2.057-11.313-5.793-2.609-3.217-7.333-3.71-10.549-1.101-3.217 2.609-3.71 7.332-1.101 10.549 5.848 7.209 14.217 11.345 22.963 11.345s17.115-4.135 22.963-11.344c2.608-3.217 2.115-7.941-1.101-10.55z"
          />
          <circle cx="239" cy="328.868" r="7.5" />
          <circle cx="290" cy="328.868" r="7.5" />
        </svg>
      </div>

      <div class="text-center">
        <p class="mt-4 text-base">ท่านมี</p>
        <p class="text-2xl font-bold">{{ finalResult }}</p>
      </div>

      <router-link
        v-if="isCompleted"
        :to="{ name: 'assessment-history.overview' }"
        class="mt-8"
        href="#"
      >
        <button
          class="border-primary border-2 bg-primary rounded px-4 py-1 text-white mt-8"
        >
          กลับไปที่ภาพรวม
        </button>
      </router-link>

      <router-link v-else :to="{ name: nextAssessment }">
        <button
          class="border-primary border-2 bg-primary rounded px-4 py-1 text-white mt-12"
        >
          ทำแบบประเมินถัดไป
        </button>
      </router-link>

      <!-- <router-link :to="{name: 'assessment-history.overview'}" class="mt-4" href="#">
        <p class="text-primary">กลับไปที่ภาพรวม</p>
      </router-link>-->
    </div>

    <div class="w-full max-w-6xl">
      <div class="mt-8 text-left">
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">ข้อสรุป</h3>
        <p class="font-normal text-justify max-w-3xl">
          ผลจากแบบชี้วัดการเปลี่ยนแปลงระดับคุณภาพชีวิต
          เน้นการประเมินการรับรู้ในเรื่องคุณภาพชีวิตของผู้ตอบแบบสอบและสามารถช่วยแพทย์ในการประเมินคุณภาพชีวิตจากการรักษาได้
          แต่ไม่ได้คาดหวังในการเป็นวิธีที่วัดในรายละเอียดของอาการของโรค
        </p>
      </div>
    </div>

    <div class="w-full max-w-6xl">
      <div class="mt-16 text-left">
        <h3 class="text-lg text-left leading-6 font-medium text-gray-900 mb-4">
          ค่าทางสถิติ
        </h3>
      </div>

      <div class="my-12">
        <whoqol-radar-chart
          :labels="radarLabels"
          :datasets="radarDataSets"
        ></whoqol-radar-chart>
      </div>

      <div class="bg-white shadow overflow-hidden mx-auto mt-0 mb-12 w-full max-w-6xl">
        <div class="px-4 pb-5 border-b border-gray-200 sm:px-6">
          <dl>
            <div class="sm:grid sm:grid-cols-3 sm:gap-4 mb-6 mt-4">
              <dd class="text-sm leading-5 font-medium text-gray-900">ค่าเฉลี่ย</dd>

              <dt
                class="mt-1 flex text-sm leading-5 text-gray-600 font-light sm:mt-0 sm:col-span-2"
              >
                {{ average }}
              </dt>
            </div>

            <div class="sm:grid sm:grid-cols-3 sm:gap-4 md:mb-0">
              <dd class="text-sm leading-5 font-medium text-gray-900">
                ส่วนเบี่ยงเบนมาตรฐาน
              </dd>
              <dt
                class="mt-1 flex text-sm leading-5 text-gray-600 font-light sm:mt-0 sm:col-span-2"
              >
                {{ standardDeviation }}
              </dt>
            </div>
          </dl>
        </div>
        <div class="px-4 py-5 sm:p-0">
          <dl>
            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5 mb-8 md:mb-0">
              <dd class="text-sm leading-5 font-medium text-gray-900">องค์ประกอบ</dd>

              <dt class="mt-1 flex text-sm leading-5 text-gray-600 sm:mt-0 sm:col-span-2">
                <div class="font-semibold w-32">ผลการประเมิน</div>

                <div class="font-semibold w-36">อยู่ในเกณฑ์</div>

                <div class="font-semibold w-40">สัดส่วนจากคะแนนรวม</div>
              </dt>
            </div>

            <div
              v-for="category in categoriesWithAnswers"
              :key="category.key"
              class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5 mb-8 md:mb-0"
            >
              <dd class="text-sm leading-5 font-medium text-gray-900">
                {{ category.name }}
              </dd>

              <dt class="mt-1 flex text-sm leading-5 text-gray-600 sm:mt-0 sm:col-span-2">
                <div :id="`${category.key}-score`" class="font-normal w-32">
                  {{ category.totalPoint.toFixed(2) }} คะแนน
                </div>

                <div class="font-normal w-36" :id="`${category.key}-result`">
                  {{ category.result.name }}
                </div>

                <div class="font-normal w-32" :id="`${category.key}-totalPoint`">
                  {{ category.ratioFromTotalScore }}%
                </div>
              </dt>
            </div>
          </dl>
        </div>
      </div>
    </div>

    <div class="w-full max-w-6xl">
      <h3 class="text-lg leading-6 font-medium text-gray-900">คำถามและตัวเลือก</h3>

      <div class="mt-4 -my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div
          class="align-middle inline-block min-w-full shadow overflow-scroll border-b border-gray-200"
        >
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  ข้อ
                </th>
                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  คำถาม
                </th>
                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  ตัวเลือก
                </th>

                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  คะแนน
                </th>

                <th
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  สัดส่วนจากคะแนนรวม
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="answer in answersWithStats"
                :key="answer.assessment.key"
                class="bg-white"
              >
                <td
                  class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  {{ answer.assessment.index }}
                </td>
                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700">
                  {{ answer.assessment.question }}
                </td>
                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700">
                  {{ answer.choice.name }}
                </td>

                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700">
                  {{ answer.choice.point }}
                </td>

                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700">
                  {{ answer.ratioFromTotalScore }}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- <div class="overflow-x-scroll">
      <table class="shadow rounded-lg ">
        <thead>
          <tr>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-sm leading-4 font-medium text-gray-900 uppercase tracking-wider">
              ข้อ
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-sm leading-4 font-medium text-gray-900 uppercase tracking-wider">
              คำถาม
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-sm leading-4 font-medium text-gray-900 uppercase tracking-wider">
              ตัวเลือก
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-sm leading-4 font-medium text-gray-900 uppercase tracking-wider">
              คะแนน
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-sm leading-4 font-medium text-gray-900 uppercase tracking-wider">
              สัดส่วนจากคะแนนรวม
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="answer in answersWithStats"
            :key="answer.assessment.key"
            class="bg-white"
          >
            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-light text-gray-700">
              {{ answer.assessment.index }}
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-900 font-medium">
              {{ answer.assessment.question }}
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700 font-light">
              {{ answer.choice.name }}
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700 font-light text-left">
              {{ answer.choice.point }}
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-700 font-light">
              {{ answer.ratioFromTotalScore }}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->
  </div>
</template>

<script>
import axios from "axios";
import collect from "collect.js";
import WhoqolRadarChart from "@/components/charts/WhoqolRadarChart.js";

export default {
  components: {
    WhoqolRadarChart,
  },
  async created() {
    let loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer,
    });

    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/whoqol-assessment/${this.$route.params.id}`,
        headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
      });

      const data = response.data.assessment;

      this.finalResult = data.final_result;
      this.rawFinalResult = JSON.parse(data.raw_final_result);
      this.answersWithStats = JSON.parse(data.raw_answers);
      this.categoriesWithAnswers = JSON.parse(data.raw_category_with_answers);
      this.average = data.average;
      this.standardDeviation = data.standard_deviation;

      this.completion = response.data.completion;

      loader.hide();
    } catch (error) {
      loader.hide();
    }
  },
  data() {
    return {
      completion: {},
      finalResult: "",
      rawFinalResult: {},
      categoriesWithAnswers: [],
      answersWithStats: [],
      average: 0,
      standardDeviation: 0,
      finalResultColors: [
        {
          result: "คุณภาพชีวิตที่ดี",
          color: "bg-green-400",
        },
        {
          result: "คุณภาพชีวิตกลางๆ",
          color: "bg-yellow-400",
        },
        {
          result: "คุณภาพชีวิตที่ไม่ดี",
          color: "bg-red-400",
        },
      ],
      modalVisibility: false,
    };
  },
  computed: {
    isCompleted() {
      if (Object.keys(this.completion).length === 0) {
        return false;
      }

      return Object.values(this.completion.assessments).every((completed) => completed);
    },

    nextAssessment() {
      const assessments = this.completion.assessments;

      if (!assessments.hplp) {
        return "assessment-hplp";
      } else {
        return "assessment-history.overview";
      }
    },

    radarDataSets() {
      const data = this?.categoriesWithAnswers.map((category) => category.totalPoint);

      return [
        {
          label: "ผลการประเมิน",
          backgroundColor: "rgba(179,181,198,0.2)",
          borderColor: "rgba(179,181,198,1)",
          pointBackgroundColor: "rgba(179,181,198,1)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgba(179,181,198,1)",
          data: collect(data).take(4).toArray(),
        },
      ];
    },
    radarLabels() {
      const labels = this?.categoriesWithAnswers.map((category) => category.name);

      return collect(labels).take(4).toArray();
    },
  },
};
</script>
